import { useRecoilState, useRecoilValue } from "recoil";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import {
  carrierAddState,
  carrierContactPerState,
  carrierData,
  carrierEditState,
  carrierMetricPerState,
  carrierShowState,
  carrierStateAppointed,
} from "../atom/atoms";
import ViewSettings from "./ViewSettings";
import EditButton from "../../../../components/EditButton";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import {
  ICarrierContactPerState,
  ICarrierMetricsPerState,
  ICarriers,
  ICarrierStateAppointed,
} from "../types";
import CarrierFullView from "./CarrierFullView";
import { useGetCarrierForEdit } from "../hooks/useGetCarrierForEdit";
interface CarrierTableProps {
  carriersData?: Array<ICarriers>;
  getCarrierLoading: true | false;
}

export const CarrierTable = ({
  carriersData = [],
  getCarrierLoading = false,
}: CarrierTableProps): JSX.Element => {
  //Permissions
  const userPermissions = useRecoilValue(permissionsSelector);
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_carrier_edit;

  const [isShowCarrier, setShowCarrier] = useRecoilState(carrierShowState);
  const addStatus = useRecoilValue(carrierAddState);
  const [editStatus, setEditStatus] = useRecoilState(carrierEditState);
  const [, setCarrierContactPerState] = useRecoilState<
    Array<ICarrierContactPerState>[]
  >(carrierContactPerState);
  const [, setCarrierMetricsPerState] = useRecoilState<
    Array<ICarrierMetricsPerState>[]
  >(carrierMetricPerState);
  const [, setCarrierStateAppointed] = useRecoilState<
    Array<ICarrierStateAppointed>[]
  >(carrierStateAppointed);
  const [, setCarrierRowData] = useRecoilState<ICarriers>(carrierData);

  const { mutate: forEdit, isLoading: loading } = useGetCarrierForEdit();

  const onClickCarrierName = (rowData: ICarriers) => {
    forEdit(rowData.masterCarrierId, {
      onSuccess: (res: ICarriers) => {
        const carrierRow = { ...res };
        setCarrierRowData(carrierRow);
        setShowCarrier(true);
      },
    });
  };

  const handleEditButton = (carrierRow) => {
    forEdit(carrierRow.masterCarrierId, {
      onSuccess: (res) => {
        const statesForEdit = res.states?.map((state) => {
          return { label: state.states, value: state.stateId };
        });
        //START Set CarrierContactsPerState in Edit Mode
        const tempContactData = [] as Array<ICarrierContactPerState>[];
        const tempMetricData = [] as Array<ICarrierMetricsPerState>[];
        res?.carrierContactPerState?.forEach((contact, cIndex) => {
          if (
            tempContactData &&
            tempContactData.filter((x) => x[0].stateId === contact.stateId)
              .length === 0
          ) {
            tempContactData.push([
              {
                parentRow: cIndex > 0 ? false : true,
                tableName: "contactState_" + contact.state,
                carrierContactPerStateId: contact.carrierContactPerStateId,
                carrierStatesId: contact.carrierStatesId,
                contactNumber: contact.contactNumber,
                contactType: contact.contactType,
                contactTypeName: contact.contactTypeName,
                email: contact.email,
                extensionNumber: contact.extensionNumber,
                name: contact.name,
                phoneTypeId: contact.phoneTypeId,
                phoneTypeName: contact.phoneTypeName,
                stateCode: contact.state,
                stateId: contact.stateId,
                eAndOId: contact.eAndOId,
                url: contact.url,
              },
            ]);
          }
        });
        tempContactData.forEach((temp, sIndex) => {
          res?.carrierContactPerState.forEach((contact) => {
            const checkContactPerStateId = (obj) =>
              obj.carrierContactPerStateId === contact.carrierContactPerStateId;
            if (temp.some(checkContactPerStateId) === false) {
              if (temp[0].stateId === contact.stateId) {
                tempContactData[sIndex].push({
                  parentRow: false,
                  tableName: "contactState_" + contact.state,
                  carrierContactPerStateId: contact.carrierContactPerStateId,
                  carrierStatesId: contact.carrierStatesId,
                  contactNumber: contact.contactNumber,
                  contactType: contact.contactType,
                  contactTypeName: contact.contactTypeName,
                  email: contact.email,
                  extensionNumber: contact.extensionNumber,
                  name: contact.name,
                  phoneTypeId: contact.phoneTypeId,
                  phoneTypeName: contact.phoneTypeName,
                  stateCode: contact.state,
                  stateId: contact.stateId,
                  eAndOId: contact.eAndOId,
                  url: contact.url,
                });
              }
            }
          });
        });
        setCarrierContactPerState([...tempContactData]);
        //END Set CarrierContactsPerState in Edit Mode

        res?.carrierMetricsPerState?.forEach((metric, mIndex) => {
          if (
            tempMetricData &&
            tempMetricData.filter((x) => x[0].stateId === metric.stateId)
              .length === 0
          ) {
            tempMetricData.push([
              {
                parentRow: mIndex > 0 ? false : true,
                tableName: "metricState_" + metric.state,
                carrierMetricsPerStateId: metric.carrierMetricsPerStateId,
                carrierStatesId: metric.carrierStatesId,
                totalPifCount: metric.totalPIFCount,
                totalPifPremium: metric.totalPIFPremium,
                newBusinessPremium: metric.newBusinessPremium,
                renewalPremium: metric.renewalPremium,
                state: metric.state,
                stateId: metric.stateId,
              },
            ]);
          }
        });
        tempMetricData.forEach((temp, sIndex) => {
          res?.carrierMetricsPerState.forEach((metric) => {
            const checkContactPerStateId = (obj) =>
              obj.carrierMetricsPerStateId === metric.carrierMetricsPerStateId;
            if (temp.some(checkContactPerStateId) === false) {
              if (temp[0].stateId === metric.stateId) {
                tempMetricData[sIndex].push({
                  parentRow: false,
                  tableName: "metricState_" + metric.state,
                  carrierMetricsPerStateId: metric.carrierMetricsPerStateId,
                  carrierStatesId: metric.carrierStatesId,
                  totalPifCount: metric.totalPIFCount,
                  totalPifPremium: metric.totalPIFPremium,
                  newBusinessPremium: metric.newBusinessPremium,
                  renewalPremium: metric.renewalPremium,
                  state: metric.state,
                  stateId: metric.stateId,
                });
              }
            }
          });
        });
        setCarrierMetricsPerState([...tempMetricData]);

        //Start Carrier State Appointed
        const tempStateAppointedData = [] as Array<ICarrierStateAppointed>[];
        res?.carrierStateAppointed.forEach((appoint, aIndex) => {
          if (
            tempStateAppointedData &&
            tempStateAppointedData.filter(
              (x) => x[0].stateId === appoint.stateId
            ).length === 0
          ) {
            tempStateAppointedData.push([
              {
                parentRow: aIndex > 0 ? false : true,
                tableName: "stateAppointed_" + appoint.states,
                stateAppointedId: appoint.stateAppointedId,
                carrierStatesId: appoint.carrierStatesId,
                newBusiness: appoint.newBusiness,
                renewalBusiness: appoint.renewalBusiness,
                newBusinessSuspended: appoint.newBusinessSuspended,
                newBusinessSuspendedDate: appoint.newBusinessSuspendedDate
                  ? appoint.newBusinessSuspendedDate.slice(0, 10)
                  : null,
                states: appoint.states,
                stateId: appoint.stateId,
              },
            ]);
          }
        });
        tempStateAppointedData.forEach((temp, sIndex) => {
          res?.carrierStateAppointed.forEach((appoint) => {
            const checkStateAppointedId = (obj) =>
              obj.stateAppointedId === appoint.stateAppointedId;
            if (temp.some(checkStateAppointedId) === false) {
              if (temp[0].stateId === appoint.stateId) {
                tempStateAppointedData[sIndex].push({
                  parentRow: false,
                  tableName: "stateAppointed_" + appoint.states,
                  stateAppointedId: appoint.stateAppointedId,
                  carrierStatesId: appoint.carrierStatesId,
                  newBusiness: appoint.newBusiness,
                  renewalBusiness: appoint.renewalBusiness,
                  newBusinessSuspended: appoint.newBusinessSuspended,
                  newBusinessSuspendedDate: appoint.newBusinessSuspendedDate
                    ? appoint.newBusinessSuspendedDate.slice(0, 10)
                    : null,
                  states: appoint.states,
                  stateId: appoint.stateId,
                });
              }
            }
          });
        });
        setCarrierStateAppointed([...tempStateAppointedData]);
        //End
        //SET National Contacts
        const natContacts = res?.nationalContacts.map((nat, index) => {
          return {
            ...nat,
            parentRow: index > 0 ? false : true,
            tableName: "nationalContacts",
          };
        });
        //SET NSA Contacts
        const nsaContacts = res?.nsaContacts.map((nsa, index) => {
          return {
            ...nsa,
            parentRow: index > 0 ? false : true,
            tableName: "nsaContacts",
          };
        });
        //SET National Contacts
        const splcContacts = res?.splcContacts.map((splc, index) => {
          return {
            ...splc,
            parentRow: index > 0 ? false : true,
            tableName: "splcContacts",
          };
        });

        setShowCarrier(false);
        setCarrierRowData({
          ...res,
          states: statesForEdit,
          nationalContacts: [...natContacts],
          nsaContacts: [...nsaContacts],
          splcContacts: [...splcContacts],
          carrierContactPerState: [...tempContactData],
          dateOfAmBestRating: res.dateOfAmBestRating
            ? new Date(res.dateOfAmBestRating).toISOString().split("T")[0]
            : null,
        });
        setEditStatus(true);
      },
    });
  };

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const matColumns = [
    {
      title: "Carrier Information",
      field: "carrierName",
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => onClickCarrierName(rowdata)}
          >
            <span className="blueAndBold underline ">
              {rowdata.carrierName} {rowdata.alias ? " - " + rowdata.alias : ""}
            </span>
          </div>
        );
      },
      sortable: true,
    },
    {
      title: "",
      render: (row) => <ViewSettings carrierDetails={row} />,
    },
    {
      title: "Status",
      field: "isActive",
      render: (row) => (row.isActive ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      title: "Action",
      align: alignCenter,
      render: (row) =>
        userPermissions.includes(editPermission) && (
          <div className="flex place-content-center mr-4">
            <EditButton
              className={"opacity-100"}
              disabled={false}
              buttonText="Edit"
              onClick={() => {
                handleEditButton(row);
              }}
            />
          </div>
        ),
    },
  ];

  return (
    <>
      {/* {(!addStatus || !editStatus) && !isShowCarrier && ( */}
      <div
        className={`${
          addStatus || editStatus || isShowCarrier ? "hidden" : "block pb-8"
        }`}
      >
        <MaterialTableTS
          columns={matColumns}
          data={carriersData}
          isLoading={getCarrierLoading}
        />
      </div>
      {/* )} */}

      {isShowCarrier && <CarrierFullView handleEditButton={handleEditButton} />}
    </>
  );
};
